import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import appearenceService from "./appearanceService";

const initialState = {
  linkStateLoading: false,
  linkStateSuccess: false,
  linkStateError: false,
  link:"",
  linkStateErrorMsg: "",
};

// _______________________createFontSettings response function and services calling
export const createLinkSettings = createAsyncThunk(
  "createLinkSettings",
  async (data, thunkAPI) => {
    try {
      const response = await appearenceService.createLinkSettings(data);
      return response;
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const linkSettingsSlice = createSlice({
  name: 'linkSettings',
  initialState,
  reducers: {
    resetLinkSettings: (state) => {
      state.linkStateLoading = false;
      state.linkStateSuccess = false;
      state.linkStateError = false;
      state.linkStateErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createLinkSettings.pending, (state) => {
        state.linkStateLoading = true;
      })
      .addCase(createLinkSettings.fulfilled, (state, action) => {
        state.linkStateLoading = false;
        state.linkStateSuccess = true;
        state.link = action.payload;
      })
      .addCase(createLinkSettings.rejected, (state, action) => {
        state.linkStateLoading = false;
        state.linkStateError = true;
        state.linkStateErrorMsg = action.payload; // error from catch will come here via action.payload and update linkErrorMsg
      });
  },
});
export const { resetLinkSettings } = linkSettingsSlice.actions;
export default linkSettingsSlice.reducer;